import { authAPIUrl, isCloud } from "@/environment";
import { LicenseService } from "@/services/license.service";

import { catched } from "./catched";

export class LicenseHandler {
  constructor() {
    this.licenseService = new LicenseService(authAPIUrl);
  }

  async getCompanyLicense() {
    return catched(this.licenseService.getLicense());
  }

  async getOnPremKey() {
    if (isCloud) {
      throw new Error("This method is only for onprem");
    }
    const result = await catched(this.licenseService.getOnPremKey());
    return result.data || "";
  }

  updateOnPremKey(license) {
    if (isCloud) {
      throw new Error("This method is only for onprem");
    }
    return catched(this.licenseService.updateOnPremKey(license));
  }
}
